import React from "react";
import { useSearch } from "../../../Contexts/SearchContext";
import {
  SEARCH_RESULTS_TO_SHOW_DESKTOP,
  SEARCH_RESULTS_TO_SHOW_MOBILE,
  SEARCH_RESULTS_TO_SHOW_TABLET
} from "../../../../constants/site-search";
import {setFilterState} from "../../../../helpers";

const FilterDrawerButtons = () => {
  const { state, dispatch } = useSearch();

  const {
    selectedFilters,
    componentElement,
  } = state;

  const resetFilters = () => {
    selectedFilters.map((filterObject) => { setFilterState(filterObject.tagId, componentElement, false); });
    dispatch({ type: "UPDATE_SELECTED_FILTERS", payload: [] });
  };

  return (
    <div className="cmp-filter-drawer-content__buttons p1 -semi-bold">
      <div className="button button--primary">
        <button
          className="cmp-button cmp-button__see-results"
          onClick={() => {
            dispatch({ type: "UPDATE_FILTER_DRAWER_IS_OPEN", payload: false });
          }}
        >
          SEE RESULTS
        </button>
      </div>
      <div className="button button--secondary">
        <button
          className="cmp-button cmp-button__reset-filters"
          onClick={resetFilters}>
          Reset Filters
        </button>
      </div>
    </div>
  );
};

export default FilterDrawerButtons;
